import {css} from 'styled-components';
import {bodyColorDark, borderColorLightest, textColor} from '../../styles';
import {colors} from '../../colors';

export const fieldLabel = css`
  width: 10rem;
  text-align: center;
  font-size: 0.8rem;
  color: ${colors.neutralPrimaryAlt};
`;

export const border = css`
  border: 1px solid ${borderColorLightest};
`;

export const cell = css`
  ${border};
  padding: 0.5rem;
  box-sizing: border-box;
`;

export const headerCell = css`
  font-size: 0.8rem;
  padding: 0.5rem;
  box-sizing: border-box;
  background-color: ${bodyColorDark};
  color: ${textColor};
  font-weight: normal;
`;
